import { render } from "./Character.vue?vue&type=template&id=6efb6a24&scoped=true"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"

import "./Character.vue?vue&type=style&index=0&id=6efb6a24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efb6a24"]])

export default __exports__